import { Status } from '@/models/status.model';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
class EdSectionStateComponent extends Vue {

  @Prop() readonly load: boolean;
  @Prop() readonly loading: boolean;
  @Prop() readonly loadingComponent: any;
  @Prop() readonly hasLoadingComponent: boolean;
  @Prop() readonly empty: boolean;
  @Prop() readonly emptyIcon: string;
  @Prop() readonly emptyMessage: string;
  @Prop() readonly emptyActionTitle: string;
  @Prop() readonly error: boolean;
  
  public readonly errorAction: string = 'errorAction';
  public readonly emptyAction: string = 'emptyAction';
  
  doEmptyAction() {
    this.$emit(this.emptyAction)
  }

  doErrorAction() {
    this.$emit(this.errorAction);
  }

}

export default Vue.component('ed-section-state', EdSectionStateComponent);